import { createApi } from '@reduxjs/toolkit/query/react';
import type {
  ReliabilityMetricsConfig,
  ReliabilityMetricsConfigCreate,
} from '@/generated/types/navigator/types.gen';
import { baseQueryWithAuth } from './utils';

export const reliabilityConfigApi = createApi({
  reducerPath: 'reliabilityConfigApi',
  baseQuery: baseQueryWithAuth,
  tagTypes: ['ReliabilityConfig'],
  endpoints: (builder) => ({
    getReliabilityMetricsConfig: builder.query<
      ReliabilityMetricsConfig | null,
      { clientCode: string }
    >({
      query: ({ clientCode }) => ({
        url: `/v1/client/${clientCode}/config/reliability_metrics/`,
        method: 'GET',
      }),
      providesTags: (_result, _error, { clientCode }) => [
        { type: 'ReliabilityConfig', id: clientCode },
      ],
    }),
    createReliabilityMetricsConfig: builder.mutation<
      ReliabilityMetricsConfig,
      { clientCode: string; body: ReliabilityMetricsConfigCreate }
    >({
      query: ({ clientCode, body }) => ({
        url: `/v1/client/${clientCode}/config/reliability_metrics/`,
        method: 'POST',
        body,
      }),
      invalidatesTags: (_result, _error, { clientCode }) => [
        { type: 'ReliabilityConfig', id: clientCode },
      ],
    }),
  }),
});

export const {
  useGetReliabilityMetricsConfigQuery,
  useCreateReliabilityMetricsConfigMutation,
} = reliabilityConfigApi;

export const resetReliabilityConfigApiState =
  reliabilityConfigApi.util.resetApiState;
